// extracted by mini-css-extract-plugin
export default {"canvas":"Scene_canvas__b1oBX"};